import * as z from 'zod';

export const GetReceiptsSettingsRequest = z.object({});
export const GetReceiptsSettingsResponse = z.object({
  receiptsSettings: z
    .object({
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the receipt settings are updated. To prevent conflicting changes, the current revision must be passed when updating the receipt settings.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the receipt settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the receipt settings were last updated.')
        .optional()
        .nullable(),
      numbering: z
        .object({
          prefix: z
            .string()
            .describe(
              'Receipt prefix that will be displayed before the receipt number.'
            )
            .min(1)
            .max(10)
            .optional()
            .nullable(),
          nextNumber: z
            .number()
            .int()
            .describe(
              'Next receipt number. Used during receipt creation to ensure unique and consecutive numbering.'
            )
            .min(1)
            .max(1000000000)
            .optional()
            .nullable(),
          suffix: z
            .string()
            .describe(
              'Receipt suffix that will be displayed after the receipt number.'
            )
            .min(1)
            .max(10)
            .optional()
            .nullable(),
        })
        .describe('Receipt numbering settings.')
        .optional(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe(
          'Custom field data for the receipt settings.\n\nExtended fields must be configured in the app dashboard before they can be accessed with API calls.'
        )
        .optional(),
    })
    .describe('Receipts settings.')
    .optional(),
});
export const UpdateReceiptsSettingsRequest = z.object({
  receiptsSettings: z
    .object({
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the receipt settings are updated. To prevent conflicting changes, the current revision must be passed when updating the receipt settings.'
        ),
      _createdDate: z
        .date()
        .describe('Date and time the receipt settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the receipt settings were last updated.')
        .optional()
        .nullable(),
      numbering: z
        .object({
          prefix: z
            .string()
            .describe(
              'Receipt prefix that will be displayed before the receipt number.'
            )
            .min(1)
            .max(10)
            .optional()
            .nullable(),
          nextNumber: z
            .number()
            .int()
            .describe(
              'Next receipt number. Used during receipt creation to ensure unique and consecutive numbering.'
            )
            .min(1)
            .max(1000000000)
            .optional()
            .nullable(),
          suffix: z
            .string()
            .describe(
              'Receipt suffix that will be displayed after the receipt number.'
            )
            .min(1)
            .max(10)
            .optional()
            .nullable(),
        })
        .describe('Receipt numbering settings.'),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe(
          'Custom field data for the receipt settings.\n\nExtended fields must be configured in the app dashboard before they can be accessed with API calls.'
        )
        .optional(),
    })
    .describe(
      'Receipt settings to update. Partial update is supported, but if no receipt settings entity exists, the full entity must be specified.'
    ),
});
export const UpdateReceiptsSettingsResponse = z.object({
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the receipt settings are updated. To prevent conflicting changes, the current revision must be passed when updating the receipt settings.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the receipt settings were created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the receipt settings were last updated.')
    .optional()
    .nullable(),
  numbering: z
    .object({
      prefix: z
        .string()
        .describe(
          'Receipt prefix that will be displayed before the receipt number.'
        )
        .min(1)
        .max(10)
        .optional()
        .nullable(),
      nextNumber: z
        .number()
        .int()
        .describe(
          'Next receipt number. Used during receipt creation to ensure unique and consecutive numbering.'
        )
        .min(1)
        .max(1000000000)
        .optional()
        .nullable(),
      suffix: z
        .string()
        .describe(
          'Receipt suffix that will be displayed after the receipt number.'
        )
        .min(1)
        .max(10)
        .optional()
        .nullable(),
    })
    .describe('Receipt numbering settings.')
    .optional(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe(
      'Custom field data for the receipt settings.\n\nExtended fields must be configured in the app dashboard before they can be accessed with API calls.'
    )
    .optional(),
});
